import * as Types from '../../types';

import { gql } from '@apollo/client';
export type ArticleChildren_ImageNode_Fragment = { __typename?: 'ImageNode', version: number, type: string, src: string, pending: boolean, format?: string | null };

export type ArticleChildren_LineBreakNode_Fragment = { __typename?: 'LineBreakNode', version: number, type: string };

export type ArticleChildren_LinkNode_Fragment = { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> };

export type ArticleChildren_TextNode_Fragment = { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string };

export type ArticleChildrenFragment = ArticleChildren_ImageNode_Fragment | ArticleChildren_LineBreakNode_Fragment | ArticleChildren_LinkNode_Fragment | ArticleChildren_TextNode_Fragment;

export type ArticleContentFragment = { __typename?: 'RootNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'CodeBlockNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'ImageNode', version: number, type: string, src: string, pending: boolean, format?: string | null } | { __typename?: 'LineBreakNode', version: number, type: string } | { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'HeadingNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, tag: string, children: Array<{ __typename?: 'ImageNode', version: number, type: string, src: string, pending: boolean, format?: string | null } | { __typename?: 'LineBreakNode', version: number, type: string } | { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'IframeNode', version: number, type: string, src: string, format?: string | null } | { __typename?: 'ListNode', version: number, type: string, tag: string, start: number, listType: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'ListItemNode', version: number, type: string, value: number, indent: number, format?: string | null, direction?: string | null, checked?: boolean | null, children: Array<{ __typename?: 'ImageNode', version: number, type: string, src: string, pending: boolean, format?: string | null } | { __typename?: 'LineBreakNode', version: number, type: string } | { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> }> } | { __typename?: 'ParagraphNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'ImageNode', version: number, type: string, src: string, pending: boolean, format?: string | null } | { __typename?: 'LineBreakNode', version: number, type: string } | { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'QuoteNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'ImageNode', version: number, type: string, src: string, pending: boolean, format?: string | null } | { __typename?: 'LineBreakNode', version: number, type: string } | { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> }> };

export const ArticleChildrenFragmentDoc = gql`
    fragment ArticleChildren on InlineNode {
  ... on TextNode {
    version
    type
    detail
    format
    mode
    style
    text
  }
  ... on LineBreakNode {
    version
    type
  }
  ... on ImageNode {
    version
    type
    src
    pending
    format
  }
  ... on LinkNode {
    version
    type
    indent
    url
    format
    direction
    children {
      version
      type
      detail
      format
      mode
      style
      text
    }
  }
}
    `;
export const ArticleContentFragmentDoc = gql`
    fragment ArticleContent on RootNode {
  version
  type
  indent
  format
  direction
  children {
    ... on ParagraphNode {
      version
      type
      indent
      format
      direction
      children {
        ...ArticleChildren
      }
    }
    ... on HeadingNode {
      version
      type
      indent
      format
      direction
      tag
      children {
        ...ArticleChildren
      }
    }
    ... on QuoteNode {
      version
      type
      indent
      format
      direction
      children {
        ...ArticleChildren
      }
    }
    ... on CodeBlockNode {
      version
      type
      indent
      format
      direction
      children {
        ...ArticleChildren
      }
    }
    ... on IframeNode {
      version
      type
      src
      format
    }
    ... on ListNode {
      version
      type
      tag
      start
      listType
      indent
      format
      direction
      children {
        version
        type
        value
        indent
        format
        direction
        checked
        children {
          ...ArticleChildren
        }
      }
    }
  }
}
    ${ArticleChildrenFragmentDoc}`;